'use client';

import styled from 'styled-components';

const Tags = styled.div`
  ul {
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
  }
  li {
    padding: 5px 10px;
    margin: 0 6px 6px 0;
    color: var(--red);
    font-size: 0.75rem;
    text-transform: uppercase;
    border: 1px solid var(--red);
    letter-spacing: 0.05rem;
    font-family: ${(props) => props.theme.fonts && props.theme.fonts.sansSerif};
    font-weight: 500;
    line-height: 1rem;
    font-weight: 600;
  }
`;

const GenreTags = ({ tags }) => (
  <Tags>
    <ul>
      {tags.map((el) => (
        <li key={el}>{el}</li>
      ))}
    </ul>
  </Tags>
);

export default GenreTags;
